export default "__VITE_ASSET__UE53zC4f__"